import { CoreFilterCommand, KnowledgeFeedOrder, KnowledgeQuickFilterType } from "generated/CoreApi_v1";
import { TFunction } from "i18next";
import { MentionTypePicker } from "views/knowledge/feed/components/FeedFilter/Pickers/MentionTypePicker";
import { RangePicker } from "views/knowledge/feed/components/FeedFilter/Pickers/RangePicker";
import { AdvFilterStandardPicker, IAdvFilterCommand, IAdvFilterDropdown, IAdvFilterMenuItem } from "../../../../general/AdvancedFilter";

///
export const sourceMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.SourceText"),
        title: t("Feed.AdvancedFilter.SourceText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeChannel,
                displayName: t("Feed.AdvancedFilter.Commands.Channel"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Channel,
                quickFilterType: KnowledgeQuickFilterType.CustomChannel
            },
            {
                command: CoreFilterCommand.KnowledgeTopic,
                displayName: t("Feed.AdvancedFilter.Commands.Topic"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Topic,
                quickFilterType: KnowledgeQuickFilterType.CustomTopic
            },
            {
                command: CoreFilterCommand.KnowledgeAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.Author"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.User,
                placeholder: t("Feed.AdvancedFilter.AuthorPlaceholder")
            },
            {
                command: CoreFilterCommand.KnowledgePublishedByYou,
                displayName: t("Feed.AdvancedFilter.Commands.PublishedByYou"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.PublishedByYou,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeUserFollowingAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.AuthorsYouFollow"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.AuthorsYouFollow,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeInstitutional,
                displayName: t("Feed.AdvancedFilter.Commands.Institutional"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                quickFilterType: KnowledgeQuickFilterType.Institutional
            },
            {
                command: CoreFilterCommand.KnowledgeTopicsYourInterest,
                displayName: t("Feed.AdvancedFilter.Commands.TopicsYourInterest"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.TopicsYourInterest,
                group: 3,
            },
            {
                command: CoreFilterCommand.KnowledgeChannelsYouAreSubscribed,
                displayName: t("Feed.AdvancedFilter.Commands.ChannelsYouAreSubscribed"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.ChannelsYouAreSubscribed,
                group: 3,
            },
        ]
    };
};

///
export const sourceChannelMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.SourceText"),
        title: t("Feed.AdvancedFilter.SourceText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeTopic,
                displayName: t("Feed.AdvancedFilter.Commands.Topic"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Topic,
                quickFilterType: KnowledgeQuickFilterType.CustomTopic
            },
            {
                command: CoreFilterCommand.KnowledgeAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.Author"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.User,
                placeholder: t("Feed.AdvancedFilter.AuthorPlaceholder")
            },
            {
                command: CoreFilterCommand.KnowledgePublishedByYou,
                displayName: t("Feed.AdvancedFilter.Commands.PublishedByYou"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.PublishedByYou,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeUserFollowingAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.AuthorsYouFollow"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.AuthorsYouFollow,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeInstitutional,
                displayName: t("Feed.AdvancedFilter.Commands.Institutional"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                quickFilterType: KnowledgeQuickFilterType.Institutional
            },
            {
                command: CoreFilterCommand.KnowledgeTopicsYourInterest,
                displayName: t("Feed.AdvancedFilter.Commands.TopicsYourInterest"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.TopicsYourInterest,
                group: 3,
            }
        ]
    };
};

///
export const sourceTopicMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.SourceText"),
        title: t("Feed.AdvancedFilter.SourceText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeChannel,
                displayName: t("Feed.AdvancedFilter.Commands.Channel"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Channel,
                quickFilterType: KnowledgeQuickFilterType.CustomChannel
            },
            {
                command: CoreFilterCommand.KnowledgeTopic,
                displayName: t("Feed.AdvancedFilter.Commands.TopicAdditional"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Topic,
                quickFilterType: KnowledgeQuickFilterType.CustomTopic
            },
            {
                command: CoreFilterCommand.KnowledgeAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.Author"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.User,
                placeholder: t("Feed.AdvancedFilter.AuthorPlaceholder")
            },
            {
                command: CoreFilterCommand.KnowledgePublishedByYou,
                displayName: t("Feed.AdvancedFilter.Commands.PublishedByYou"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.PublishedByYou,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeUserFollowingAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.AuthorsYouFollow"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.AuthorsYouFollow,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeInstitutional,
                displayName: t("Feed.AdvancedFilter.Commands.Institutional"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                quickFilterType: KnowledgeQuickFilterType.Institutional
            },
            {
                command: CoreFilterCommand.KnowledgeChannelsYouAreSubscribed,
                displayName: t("Feed.AdvancedFilter.Commands.ChannelsYouAreSubscribed"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.ChannelsYouAreSubscribed,
                group: 3,
            },
        ]
    };
};

///
export const sourceAuthorMenuOptions = (t: TFunction, canFilterAuthor: boolean): IAdvFilterDropdown => {
    let menuOptions: IAdvFilterDropdown = {
        textOrIcon: t("Feed.AdvancedFilter.SourceText"),
        title: t("Feed.AdvancedFilter.SourceText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeChannel,
                displayName: t("Feed.AdvancedFilter.Commands.Channel"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Channel,
                quickFilterType: KnowledgeQuickFilterType.CustomChannel
            },
            {
                command: CoreFilterCommand.KnowledgeTopic,
                displayName: t("Feed.AdvancedFilter.Commands.Topic"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.Topic,
                quickFilterType: KnowledgeQuickFilterType.CustomTopic
            },
            {
                command: CoreFilterCommand.KnowledgeAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.Author"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.User,
                placeholder: t("Feed.AdvancedFilter.AuthorPlaceholder")
            },
            {
                command: CoreFilterCommand.KnowledgePublishedByYou,
                displayName: t("Feed.AdvancedFilter.Commands.PublishedByYou"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.PublishedByYou,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeUserFollowingAuthor,
                displayName: t("Feed.AdvancedFilter.Commands.AuthorsYouFollow"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.AuthorsYouFollow,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeInstitutional,
                displayName: t("Feed.AdvancedFilter.Commands.Institutional"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                quickFilterType: KnowledgeQuickFilterType.Institutional
            },
            {
                command: CoreFilterCommand.KnowledgeTopicsYourInterest,
                displayName: t("Feed.AdvancedFilter.Commands.TopicsYourInterest"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.TopicsYourInterest,
                group: 3,
            },
            {
                command: CoreFilterCommand.KnowledgeChannelsYouAreSubscribed,
                displayName: t("Feed.AdvancedFilter.Commands.ChannelsYouAreSubscribed"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.ChannelsYouAreSubscribed,
                group: 3,
            },
        ]
    };

    if (!canFilterAuthor) {
        menuOptions = {
            ...menuOptions,
            filterCommands: menuOptions.filterCommands.filter(x => x.command != CoreFilterCommand.KnowledgeAuthor && x.command != CoreFilterCommand.KnowledgePublishedByYou && x.command != CoreFilterCommand.KnowledgeUserFollowingAuthor)
        };
    }

    return menuOptions;
};

///
export const containsMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.ContainingText"),
        title: t("Feed.AdvancedFilter.ContainingText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeContainVideo,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsVideo"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Video,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeContainAudio,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsAudio"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Audio,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeContainImage,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsImage"),
                canRepeat: false,
                canCheck: true,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeContainsPresentation,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsPresentation"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Presentation,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeContainLink,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsLink"),
                canRepeat: false,
                canCheck: true,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeContainDocument,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsDocument"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.ContainAttach,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeContainMention,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsMention"),
                canRepeat: false,
                canCheck: true,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeContainShorts,
                displayName: t("Feed.AdvancedFilter.Commands.ContainsShorts"),
                canRepeat: false,
                canCheck: true,
                group: 3,
            },
        ]
    };
};

///
export const periodMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.PeriodText"),
        title: t("Feed.AdvancedFilter.PeriodText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.Today"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 1,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.Week"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                quickFilterType: KnowledgeQuickFilterType.LastWeek,
                fixedValue: 2,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.Month"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                quickFilterType: KnowledgeQuickFilterType.LastMonth,
                fixedValue: 3,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.TwoMoth"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 4,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.Quarter"),
                canRepeat: false,
                canCheck: true,
                group: 1,
                fixedValue: 5,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgePeriod,
                displayName: t("Feed.AdvancedFilter.Commands.Year"),
                canRepeat: false,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.LastYear,
                group: 1,
                fixedValue: 6,
                optionGroup: 1
            },
            {
                command: CoreFilterCommand.KnowledgeModifiedOn,
                displayName: t("Feed.AdvancedFilter.Commands.ModifiedOn"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                picker: AdvFilterStandardPicker.Period,
                displayPreText: t("Feed.AdvancedFilter.ModifiedText")
            },
            {
                command: CoreFilterCommand.KnowledgeCreatedOn,
                displayName: t("Feed.AdvancedFilter.Commands.CreatedOn"),
                canRepeat: false,
                canCheck: true,
                group: 2,
                picker: AdvFilterStandardPicker.Period,
                displayPreText: t("Feed.AdvancedFilter.CreationText")
            },
        ]
    };
};

export const periodAdminMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    const periodOptions = periodMenuOptions(t);

    const additionalFilterCommands =
        [{
            command: CoreFilterCommand.KnowledgeExpired,
            displayName: t("Feed.AdvancedFilter.Commands.Expired"),
            canRepeat: false,
            canCheck: false,
            group: 3,
        },
        {
            command: CoreFilterCommand.KnowledgeAvailableInTheFuture,
            displayName: t("Feed.AdvancedFilter.Commands.AvailableInTheFuture"),
            canRepeat: false,
            canCheck: false,
            group: 3,
        }];

    return { ...periodOptions, filterCommands: periodOptions.filterCommands.concat(additionalFilterCommands) };
};

///
export const stickersMenuOptions = (t: TFunction, filterCommands: IAdvFilterCommand[]): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.StickersText"),
        title: t("Feed.AdvancedFilter.StickersText"),
        filterCommands
    };
};

///
export const othersMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.OtherFiltersText"),
        title: t("Feed.AdvancedFilter.OtherFiltersText"),
        filterCommands: [
            {
                command: CoreFilterCommand.KnowledgeNotSeenByYou,
                displayName: t("Feed.AdvancedFilter.Commands.NotSeenByYou"),
                canRepeat: true,
                canCheck: true,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeSeenByYou,
                displayName: t("Feed.AdvancedFilter.Commands.SeenByYou"),
                canRepeat: true,
                canCheck: true,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeLiked,
                displayName: t("Feed.AdvancedFilter.Commands.Liked"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Liked,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeLikedCoworks,
                displayName: t("Feed.AdvancedFilter.Commands.LikedCoworks"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.CoworkerLiked,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeRecommended,
                displayName: t("Feed.AdvancedFilter.Commands.Recommended"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Recommended,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeTrending,
                displayName: t("Feed.AdvancedFilter.Commands.Trending"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Trending,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeMentioningYou,
                displayName: t("Feed.AdvancedFilter.Commands.MentioningYou"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.MentioningYou,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeMentioning,
                displayName: t("Feed.AdvancedFilter.Commands.Mentioning"),
                canRepeat: true,
                group: 1,
                picker: AdvFilterStandardPicker.User,
                placeholder: t("Feed.AdvancedFilter.MentionPlaceholder")
            },
            {
                command: CoreFilterCommand.KnowledgeRestrictedAccess,
                displayName: t("Feed.AdvancedFilter.Commands.RestrictedAccess"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.RestrictedAccess,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgePost,
                displayName: t("Feed.AdvancedFilter.Commands.Post"),
                canRepeat: true,
                canCheck: true,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeQuestion,
                displayName: t("Feed.AdvancedFilter.Commands.Question"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Question,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeList,
                displayName: t("Feed.AdvancedFilter.Commands.List"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.List,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgePoll,
                displayName: t("Feed.AdvancedFilter.Commands.Poll"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Poll,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeContent,
                displayName: t("Feed.AdvancedFilter.Commands.Content"),
                canRepeat: true,
                group: 3,
            },
        ]
    };
};

///
export const othersChannelMenuOptions = (t: TFunction, registered: boolean): IAdvFilterDropdown => {
    let otherOptions = othersMenuOptions(t);
    if (!registered) {
        otherOptions.filterCommands = otherOptions.filterCommands.filter(x => x.command != CoreFilterCommand.KnowledgeRestrictedAccess);
    }
    return otherOptions;
};

///
export const othersAdminMenuOptions = (t: TFunction): IAdvFilterDropdown => {
    return {
        textOrIcon: t("Feed.AdvancedFilter.OtherFiltersText"),
        title: t("Feed.AdvancedFilter.OtherFiltersText"),
        filterCommands: [
            //1
            {
                command: CoreFilterCommand.KnowledgeSeenByYou,
                displayName: t("Feed.AdvancedFilter.Commands.SeenByYou"),
                canRepeat: true,
                canCheck: true,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeNotSeenByYou,
                displayName: t("Feed.AdvancedFilter.Commands.NotSeenByYou"),
                canRepeat: true,
                canCheck: true,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeTrending,
                displayName: t("Feed.AdvancedFilter.Commands.Trending"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Trending,
                group: 1,
            },
            {
                command: CoreFilterCommand.KnowledgeMentioning,
                displayName: t("Feed.AdvancedFilter.Commands.Mentioning"),
                canRepeat: true,
                group: 1,
                CustomPicker: MentionTypePicker,
                options:
                    [
                        {
                            command: CoreFilterCommand.KnowledgeMentioningUser,
                            displayName: t("Feed.AdvancedFilter.Commands.MentioningUser"),
                            canRepeat: true,
                            group: 1
                        },
                        {
                            command: CoreFilterCommand.KnowledgeMentioningTopic,
                            displayName: t("Feed.AdvancedFilter.Commands.MentioningTopic"),
                            canRepeat: true,
                            group: 1
                        },
                        {
                            command: CoreFilterCommand.KnowledgeMentioningChannel,
                            displayName: t("Feed.AdvancedFilter.Commands.MentioningChannel"),
                            canRepeat: true,
                            group: 1
                        },
                        {
                            command: CoreFilterCommand.KnowledgeMentioningPublication,
                            displayName: t("Feed.AdvancedFilter.Commands.MentioningPublication"),
                            canRepeat: true,
                            group: 1
                        }
                    ]
            },
            //2
            {
                command: CoreFilterCommand.KnowledgePost,
                displayName: t("Feed.AdvancedFilter.Commands.Post"),
                canRepeat: true,
                canCheck: true,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeQuestion,
                displayName: t("Feed.AdvancedFilter.Commands.Question"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Question,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgeList,
                displayName: t("Feed.AdvancedFilter.Commands.List"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.List,
                group: 2,
            },
            {
                command: CoreFilterCommand.KnowledgePoll,
                displayName: t("Feed.AdvancedFilter.Commands.Poll"),
                canRepeat: true,
                canCheck: true,
                quickFilterType: KnowledgeQuickFilterType.Poll,
                group: 2,
            },
            //3
            {
                command: CoreFilterCommand.KnowledgeModifiedByManagerOrSupervisor,
                displayName: t("Feed.AdvancedFilter.Commands.ModifiedByManagerOrSupervisor"),
                canRepeat: false,
                canCheck: true,
                group: 3,
            },
            {
                command: CoreFilterCommand.KnowledgeBlocked,
                displayName: t("Feed.AdvancedFilter.Commands.Blocked"),
                canRepeat: false,
                canCheck: true,
                group: 3,
            },
            //4
            {
                command: CoreFilterCommand.KnowledgeViewsCount,
                displayName: t("Feed.AdvancedFilter.Commands.ViewsCount"),
                canRepeat: false,
                canCheck: false,
                group: 4,
                CustomPicker: RangePicker
            },
            {
                command: CoreFilterCommand.KnowledgeLikesCount,
                displayName: t("Feed.AdvancedFilter.Commands.LikesCount"),
                canRepeat: false,
                canCheck: false,
                group: 4,
                CustomPicker: RangePicker
            },
            {
                command: CoreFilterCommand.KnowledgeCommentsCount,
                displayName: t("Feed.AdvancedFilter.Commands.CommentsCount"),
                canRepeat: false,
                canCheck: false,
                group: 4,
                CustomPicker: RangePicker
            },
            //5
            {
                command: CoreFilterCommand.KnowledgeContent,
                displayName: t("Feed.AdvancedFilter.Commands.Content"),
                canRepeat: true,
                group: 5,
            },
        ]
    };
};

///
export function orderMenuOptions(t: TFunction): IAdvFilterMenuItem<KnowledgeFeedOrder>[] {
    const options = [
        { text: t("Feed.AdvancedFilter.Order.MostRelevant"), value: KnowledgeFeedOrder.MostRelevant, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostRecent"), value: KnowledgeFeedOrder.Latest, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostViewed"), value: KnowledgeFeedOrder.MostViewed, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MoreLikes"), value: KnowledgeFeedOrder.MostLiked, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostCommented"), value: KnowledgeFeedOrder.MostCommented, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.Title"), value: KnowledgeFeedOrder.Title, group: 1 }
    ];

    return options;
}

///
export function orderMenuAdminOptions(t: TFunction): IAdvFilterMenuItem<KnowledgeFeedOrder>[] {
    const options = [
        { text: t("Feed.AdvancedFilter.Order.MostRelevant"), value: KnowledgeFeedOrder.MostRelevant, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostRecent"), value: KnowledgeFeedOrder.Latest, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostViewed"), value: KnowledgeFeedOrder.MostViewed, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MoreLikes"), value: KnowledgeFeedOrder.MostLiked, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.MostCommented"), value: KnowledgeFeedOrder.MostCommented, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.GreatestStorageSize"), value: KnowledgeFeedOrder.GreatestStorageSize, group: 1 },
        { text: t("Feed.AdvancedFilter.Order.Title"), value: KnowledgeFeedOrder.Title, group: 1 }
    ];

    return options;
}
